// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_AutocompleteTableFilter_filterBar__HvQH5 {
  width: 100%;
  min-width: 200px;
}

.storage_AutocompleteTableFilter_filterLabel__ovTna {
  margin-bottom: 4px;
  color: var(--color-grey-08);
  font-size: 14px;
}

.storage_AutocompleteTableFilter_autocomplete__aptvV {
  min-height: 37px !important;
  padding-top: 2px;
}

@media (max-width: 480px) {
  .storage_AutocompleteTableFilter_filterBar__HvQH5 {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AutocompleteTableFilter/AutocompleteTableFilter.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".filterBar {\n  width: 100%;\n  min-width: 200px;\n}\n\n.filterLabel {\n  margin-bottom: 4px;\n  color: var(--color-grey-08);\n  font-size: 14px;\n}\n\n.autocomplete {\n  min-height: 37px !important;\n  padding-top: 2px;\n}\n\n@media (max-width: 480px) {\n  .filterBar {\n    width: 100%;\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterBar": `storage_AutocompleteTableFilter_filterBar__HvQH5`,
	"filterLabel": `storage_AutocompleteTableFilter_filterLabel__ovTna`,
	"autocomplete": `storage_AutocompleteTableFilter_autocomplete__aptvV`
};
export default ___CSS_LOADER_EXPORT___;
